// src/pages/SchemeOfWork.jsx
import React from 'react';
import './SchemeOfWork.css';

const SchemeOfWork = () => {
  return (
    <div className="scheme-page">
      <div className="scheme-container">
        <div className="scheme-content">
          {/* Construction icon */}
          <div className="construction-icon">
            <div className="hard-hat">👷</div>
          </div>
          
          <h1 className="scheme-title">
            Scheme of Work
            <span className="title-highlight"> Coming Soon</span>
          </h1>
          
          <p className="scheme-description">
            We're currently building a comprehensive collection of CBC Schemes of Work 
            for all grades. Our team is working hard to provide high-quality, 
            curriculum-aligned resources for teachers and educators.
          </p>
          
          <div className="scheme-features">
            <h2 className="features-title">What to Expect:</h2>
            <ul className="features-list">
              <li className="feature-item">
                <span className="feature-icon">📚</span>
                <span className="feature-text">Complete termly schemes for all subjects</span>
              </li>
              <li className="feature-item">
                <span className="feature-icon">🎯</span>
                <span className="feature-text">CBC curriculum-aligned content</span>
              </li>
              <li className="feature-item">
                <span className="feature-icon">📝</span>
                <span className="feature-text">Downloadable PDF format</span>
              </li>
              <li className="feature-item">
                <span className="feature-icon">👨‍🏫</span>
                <span className="feature-text">Teacher-friendly lesson plans</span>
              </li>
            </ul>
          </div>
          
          <div className="scheme-back">
            <a href="/" className="back-link">
              ← Back to Home
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SchemeOfWork;